module.exports = __webpack_public_path__ + "static/digital6d33f26734b035b74cb4fbd410f3ec00e.png";